/**
 * usePageLanguage — the ONE reading of "the language this page is showing", for a public form that sends an email to
 * someone with no account (EMAIL-LOCALE-ZONE-001; owner rulings #6, the access request, and #9, the company-address
 * reminder). The page REPORTS its language (react-i18next's `resolvedLanguage`, else `language`); the server JUDGES it
 * (`@puffin-core/email-templates` `acceptedEmailLanguage`) and falls back when it is not one the emails ship. With no
 * i18n instance there is none, and `JSON.stringify` drops the field.
 *
 * @module @puffin-core/login-shell/hooks/usePageLanguage
 */

import { useTranslation } from 'react-i18next';

/**
 * @returns {string|undefined} The language the page is showing, or none.
 */
export function usePageLanguage() {
  const { i18n } = useTranslation();
  return i18n?.resolvedLanguage || i18n?.language;
}

export default usePageLanguage;
